import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { Navigator } from "../../../components/menu/navigator";
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IValidateLoginCodeRequestData } from 'src/app/interfaces/authentication.interface';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { Clipboard } from '@capacitor/clipboard';
import { CustomerModel } from 'src/app/models/customer-model';



@Component({
  selector: 'app-authenticator-app-setup',
  templateUrl: './authenticator-app-setup.component.html',
  styleUrls: ['./authenticator-app-setup.component.scss'],
})
export class AuthenticatorAppSetupComponent  implements OnInit {

  @ViewChild(IonContent, {static: false}) content: IonContent;

  @Input() customerId: any;
  @Input() callback: () => void;
  @Input() governmentId: any;
  @Input() onClose: () => void;
  @Input() isMFAFirst: any;
  @Input() isUpdate2FA: boolean;
  @Input() isRegistration: boolean;

  error = null;
  authenticatorAppSetupForm: FormGroup;
  showQRCode: boolean = false;
  QRCodeURL: any;
  textTags: { [key: string]: string };
  verifiedCode = false;
  secretKeyForQRCode;
  customer: CustomerModel;
  isActiveCustomer: boolean = false;
  verifyCalled: boolean = false;
  kycCalled: boolean = false;
  kbaCalled: boolean = false;
  constructor(
    public successMessageService: SuccessMessageService,
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private authenticationService: AuthenticationService,
    public globalErrorHandlerService: GlobalErrorHandlerService,
    private logoutService: LogoutService
  ) { }

  ngOnInit() {
    this.callShowQRCode();
    this.getCustomerInfo();
    this.authenticatorAppSetupForm = new FormGroup({
      digit1: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit2: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit3: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit4: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit5: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit6: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)])
		});

  }

  getCustomerInfo(){
    this.userSessionService.getCustomer().subscribe((customer: CustomerModel) => {
      if(customer){
        this.customer = customer;
        this.isActiveCustomer = this.customer.status.toLowerCase() === "active" ? true : false;
      }
    })
  }



  onDigitInput(index: number, event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    if (target.value.length > 1) {
      target.value = target.value.slice(0, 1); // Limit to one digit
    }

    this.authenticatorAppSetupForm.get(`digit${index + 1}`)?.setValue(target.value);
    if (target.value && index < 5) {
      (document.getElementsByTagName('ion-input')[index + 1].getInputElement() as unknown as Promise<HTMLIonInputElement>).then(inputElement => {
        inputElement.focus();
      });
    } else if (!target.value && index > 0) {
      // Move to the previous input if the current one is empty
      (document.getElementsByTagName('ion-input')[index - 1].getInputElement() as unknown as Promise<HTMLIonInputElement>).then(inputElement => {
        inputElement.focus();
      });
    }
  }

  handleKeydown(event: KeyboardEvent, index: number) {
    const target = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !target.value && index > 0) {
      (document.getElementById(`digit${index}`) as HTMLInputElement)?.focus();
    }
  }


  callShowQRCode(){
    this.authenticationService.callShowQRCode().subscribe({
      next: response => {
        if (response.result == 1) {
          this.QRCodeURL = response.payload;
          this.secretKeyForQRCode = new URL(this.QRCodeURL).searchParams.get('data')?.match(/secret=([^&]*)/)?.[1];
          this.showQRCode = true;
        }
      },
      error: error => {
        this.showQRCode = false;
        switch (error.getErrorCode().toUpperCase()) {
          default:
            error.setErrorMessage(
              'An error has occured while generating QR Code. Please try again.'
            );
            break;
        }
        this.error = error;
        this.content.scrollToTop(10);
      }
    })
  }

  doVerify(){
    if(this.verifyCalled){
      return;
    }
    this.verifyCalled = true;

    const combinedValue =
      this.authenticatorAppSetupForm.value.digit1 +
      this.authenticatorAppSetupForm.value.digit2 +
      this.authenticatorAppSetupForm.value.digit3 +
      this.authenticatorAppSetupForm.value.digit4 +
      this.authenticatorAppSetupForm.value.digit5 +
      this.authenticatorAppSetupForm.value.digit6;
    const data: IValidateLoginCodeRequestData = {
      customerId: this.customerId ? this.customerId : this.customer.customerId,
      pinNumber: combinedValue,
      target: 'auth_app'
    }
    this.authenticationService.validateLoginCode(data).subscribe({
      next: response => {
        if (response && !!response.result) {
          this.verifiedCode = true;
          if (this.isUpdate2FA) {
            this.updateUserSelection();
          } else {
            this.doKYC();
          }

        }
        if('code' in response) {
          const error = this.globalErrorHandlerService;
          switch (response.code) {
              case 'GOVERNMENT_ID_ALREADY_EXISTS':
                error.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
                break;
              case 'LOGIN_CODE_NOT_FOUND':
                  error.setErrorMessage('Wrong code.');
                  this.authenticatorAppSetupForm.setErrors({ 'LOGIN_CODE_NOT_FOUND': true });
                  this.authenticatorAppSetupForm.markAsDirty();
                  this.authenticatorAppSetupForm.markAsTouched();
                  break;
              case 'LOGIN_CODE_EXPIRED':
                  error.setErrorMessage('Code expired.');
                  this.authenticatorAppSetupForm.setErrors({ 'LOGIN_CODE_EXPIRED': true });
                  this.authenticatorAppSetupForm.markAsDirty();
                  this.authenticatorAppSetupForm.markAsTouched();
                  break;
              case 'FAILED_TOO_MANY_ATTEMPTS':
                  error.setErrorMessage('Your account was disabled upon too many failed logins, please contact support.');
                  break;
              case "NOT_VALID_TOKEN":
                    this.authenticatorAppSetupForm.setErrors({ LOGIN_CODE_NOT_FOUND: true });
                    this.authenticatorAppSetupForm.markAsDirty();
                    this.authenticatorAppSetupForm.markAsTouched();
                    error.setErrorMessage('The token provided is not valid');
                    break;
              default:
                  error.setErrorMessage('An error has occured logging you in. Please try again.');
                  this.authenticatorAppSetupForm.setErrors({ 'LOGIN_CODE_SERVER_ERROR': true });
                  this.authenticatorAppSetupForm.markAsDirty();
                  this.authenticatorAppSetupForm.markAsTouched();
                  break;
          }
          this.error = error;
          this.authenticatorAppSetupForm.reset();
          this.content.scrollToTop(10);
      } else {
        this.verifiedCode = true;
        if (this.isUpdate2FA) {
          this.updateUserSelection();
        } else {
          this.doKYC();
        }
      }
      
      this.verifyCalled = false;
      },
      error: error => {
        switch (error.getErrorCode().toUpperCase()) {
          case 'LOGIN_CODE_NOT_FOUND':
            error.setErrorMessage('Wrong code.');
            this.authenticatorAppSetupForm.setErrors({ LOGIN_CODE_NOT_FOUND: true });
            this.authenticatorAppSetupForm.markAsDirty();
            this.authenticatorAppSetupForm.markAsTouched();
            break;
          case 'LOGIN_CODE_EXPIRED':
            error.setErrorMessage('Code expired.');
            this.authenticatorAppSetupForm.setErrors({ LOGIN_CODE_EXPIRED: true });
            this.authenticatorAppSetupForm.markAsDirty();
            this.authenticatorAppSetupForm.markAsTouched();
            break;
          case 'FAILED_TOO_MANY_ATTEMPTS':
            error.setErrorMessage('Your account was disabled upon too many failed logins, please contact support.');
            break;
          case 'GOVERNMENT_ID_ALREADY_EXISTS':
          error.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
            break;
          case "NOT_VALID_TOKEN":
            this.authenticatorAppSetupForm.setErrors({ LOGIN_CODE_NOT_FOUND: true });
            this.authenticatorAppSetupForm.markAsDirty();
            this.authenticatorAppSetupForm.markAsTouched();
            error.setErrorMessage('The token provided is not valid');
            break;
          default:
            error.setErrorMessage('An error has occured logging you in. Please try again.');
            this.authenticatorAppSetupForm.setErrors({ LOGIN_CODE_SERVER_ERROR: true });
            this.authenticatorAppSetupForm.markAsDirty();
            this.authenticatorAppSetupForm.markAsTouched();
            break;
        }
        this.verifiedCode = false;
        this.error = error;
        this.authenticatorAppSetupForm.reset();
        this.content.scrollToTop(10);
        this.verifyCalled = false;
      },
    })
  }

  public doKYC(): any {
    if(this.kycCalled){
      return;
    }
    this.kycCalled = true;
    const customer_id = this.authenticationService.customer.customerId;
    const government_id = this.governmentId;
    const obj = {
      customer_id,
      government_id,
    }
    this.authenticationService.callVerifyKYC(obj).subscribe({
      next: (response) => {
        if (response.result == 1) {
          let payloadObject = response.payload;
          if ((Object.keys(payloadObject).length > 0 && payloadObject.constructor === Object) && payloadObject.hasOwnProperty('is_verified')) {
            const isVerified = response.payload.is_verified;
            const kycStep = response.payload.kyc_step;
            const kyc_attempts = response.payload.kyc_attempts;
            const kycFailErrors = response.payload.kyc_fail_errors;
            const idScanResult = response.payload.id_scan_result;
            if (isVerified === "true") return this.activateCustomer();
            this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
          }
        }
      },
      error: (error) => {
        console.log("ERROR", error)
        this.error = error;
        this.signUpStepTwo();
      }
  });
  }

  startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult?) {
    if(this.kbaCalled){
      return;
    }
    this.kbaCalled = true;
    this.userSessionService.setMFAApproval("true");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_KBA') return this.navigator.navigateTo("IdologyKbaComponent");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_RETRY') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: false, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_SOVOS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_CS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult === 'pending') return this.navigator.navigateTo("CamsComponent");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult !== 'pending') return this.navigator.navigateTo("CamsComponent");
    return this.navigator.navigateTo("InvalidKycComponent", {}, { kycFailErrors: kycFailErrors, dontCallAppInitNext: true });
  }

  public signUpStepTwo = () => {
    return this.navigator.navigateTo("SignupStepTwoComponent", {forceModal: true}, { KYCError: this.error});
  }

  activateCustomer = () => {
    this.navigator.navigateTo("SignupResultComponent", { forceModal: true });
  }

  closeModal = () => {
    if(this.isUpdate2FA){
      this.navigator.toLobby();
    } else {
      if (!this.verifiedCode) {
        const onClose = this.onClose;
        if (onClose) {
          this.navigator.dismiss();
          onClose();
        } else {
          this.navigator.dismiss();
          return this.logoutService.onLogout();
        }
      } else {
        return setTimeout(() => {
          this.validateUserAction();
        }, 1000);
      }
    }

  };

  validateUserAction() {
    const isMFAFirst = this.isMFAFirst;
    if (isMFAFirst) {
      this.doKYC();
    } else {
      const callBackFn = this.callback;
      if (callBackFn) {
        this.navigator.dismiss();
        callBackFn();
      } else {
        this.navigator.toLobby();
      }
    }
  }

  async copyToClipboard(){
    await Clipboard.write({
      string: this.secretKeyForQRCode
    });
  }

  goBack(){
    if(this.isUpdate2FA){
      this.navigator.navigateTo("ChangeAuthenticatorOptionComponent", { forceModal: true });
    } else {
      this.navigator.navigateTo("AuthenticatorOptionComponent", { forceModal: true },{ customerId: this.customerId, isMFAFirst: this.isMFAFirst, governmentId: this.governmentId, onClose: this.onClose });
    }

  }

  updateUserSelection(){
    this.userSessionService.refreshCustomer();
    this.navigator.navigateTo("AuthenticatorChangeSuccessComponent");
  }

  onBack = () => {
    this.navigator.navigateTo("AuthenticatorOptionComponent", { forceModal: true },{ customerId: this.customerId, isMFAFirst: this.isMFAFirst, governmentId: this.governmentId, onClose: this.onClose });
  }



}
